"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDuplicateReadings = void 0;
const core_services_1 = require("@iotv/core-services");
/** utility to return duplicate readings { timestamp: number } */
const getDuplicateReadings = (readings) => {
    const unigueMeessage = [];
    const duplicateFilter = (ob) => {
        return !!unigueMeessage.find((um) => um.timestamp === ob.timestamp);
    };
    const duplicatesFilter = (0, core_services_1.getRejectionBucketingFilter)({ filter: duplicateFilter, rejectionsBucket: unigueMeessage });
    const duplicates = readings.filter(duplicatesFilter);
    console.log(`Found ${duplicates.length} duplicates out of ${readings.length} total results`);
    return duplicates;
};
exports.getDuplicateReadings = getDuplicateReadings;
